import IntuetyGuidance from "./intuetyGuidance";

export default IntuetyGuidance;